import { CompassOutlined } from "@ant-design/icons";
import { Button } from "antd";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);

const IST = "Asia/Kolkata";

export const renderBoolean = (cellValue: boolean) => (
  <p className="mx-auto">{cellValue ? "Yes" : "No"}</p>
);

export const renderDistanceLinkGen = (
  cellValue: string,
) => {
  return (
    <Button
      size="small"
      type="link"
      className="tail-mx-auto"
      icon={<CompassOutlined></CompassOutlined>}
      iconPosition="end"
      href={cellValue}
      target="_blank"
    >
      View Distance
    </Button>
  )
}
export function dateDisplayable(dateAsString: string){
  if (!dateAsString) return "";
  return dayjs.utc(dateAsString).tz(IST).format("DD-MM-YYYY");
}

export function dateTimeDisplayable(dateAsString?: string | null){
  if (!dateAsString) return "";
  return dayjs.utc(dateAsString).tz(IST).format("DD-MM-YYYY hh:mm A");
}